import type { CustomerDTO } from '@six-pockets/shared';
import { Avatar, Button } from '@/components/ui';
import { formatPhone } from '@/utils/format';
import styles from '@/styles/components/CustomerCard/style.scss';

export function CustomerCard({ customer, onChange }: { customer: CustomerDTO; onChange: () => void }) {
  return (
    <div className={styles.card}>
      <Avatar name={customer.name} tone="green" />
      <span className={styles.text}>
        <span className={styles.name}>{customer.name}</span>
        <span className={styles.phone}>{formatPhone(customer.phone)}</span>
      </span>
      <Button size="sm" variant="secondary" onClick={onChange}>
        Change
      </Button>
    </div>
  );
}
